import { render } from "./LicenseList.vue?vue&type=template&id=28905109&scoped=true"
import script from "./LicenseList.vue?vue&type=script&lang=js"
export * from "./LicenseList.vue?vue&type=script&lang=js"

import "./LicenseList.vue?vue&type=style&index=0&id=28905109&scoped=true&lang=css"
import "./LicenseList.vue?vue&type=style&index=1&id=28905109&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28905109"]])

export default __exports__